// extracted by mini-css-extract-plugin
module.exports = {"createPasswordPage":"CreatePasswordPage_createPasswordPage__21-uE","createPasswordBlock":"CreatePasswordPage_createPasswordBlock__1cVoG"};